<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="agentName" :showBackButton="true" :backRoute="getHomeRoute" :isEdit="false"></app-view-toolbar>
    <template v-if="!viewDataIsLoaded">
      <v-row>
        <v-col cols="12" sm="6">
          <v-skeleton-loader
            type="card-heading, list-item-three-line"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="6">
          <v-skeleton-loader
            type="card-heading, list-item-three-line"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="12" sm="6">
          <!--accessibility-->
          <v-card
            class="mx-auto pa-0 mb-4"
            :outlined="true"
            v-if="isDriver"
          >
            <v-card-title
              class="d-flex py-2 xCardTitle"
            >
              <div class="text-overline">Tillgänglighet</div>
              <!--
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                color="secondary"
                @click="lazySaveAccessibility()"
              >
                <v-icon left>mdi-check</v-icon>
                Spara
              </v-btn>
              -->
            </v-card-title>
            <v-card-text
              class="pb-0"
            >
              <v-form ref="formAccessibility" v-on:submit.prevent>
                <div class="text-subtitle-2 py-2">Veckodagar</div>
                <div>
                  <v-btn-toggle
                    v-model="viewData.accessibilityData.assignmentWeekdayAll"
                    class="mb-3 xDenseToggle"
                    color="blue darken-4"
                    mandatory
                  >
                    <v-btn
                      v-for="weekdayMode in weekdayModes"
                      :key="weekdayMode.value"
                      :value="weekdayMode.value"
                      text
                      small
                      @click="lazySaveAccessibility()"
                    >
                      {{ weekdayMode.name }}
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <div>
                  <v-btn-toggle
                    v-if="viewData.accessibilityData.assignmentWeekdayAll == 0"
                    v-model="viewData.accessibilityData.assignmentWeekday_ar"
                    multiple
                    class="mb-3 xDenseToggle"
                    color="blue darken-4"
                  >
                    <v-btn
                      v-for="weekday in weekdays"
                      :key="weekday.value"
                      :value="weekday.value"
                      text
                      small
                      @click="lazySaveAccessibility()"
                    >
                      {{ weekday.name }}
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <template v-if="showJobLengthButtons">
                  <div class="text-subtitle-2 pb-2">Jobblängd</div>
                  <v-btn-toggle
                    v-model="viewData.accessibilityData.assignmentSingleDayOnly"
                    class="mb-3 xDenseToggle"
                    color="blue darken-4"
                    mandatory
                  >
                    <v-btn
                      v-for="dayMode in dayModes"
                      :key="dayMode.value"
                      :value="dayMode.value"
                      text
                      small
                      @click="lazySaveAccessibility()"
                    >
                      {{ dayMode.name }}
                    </v-btn>
                  </v-btn-toggle>
                </template>
                <template v-if="showMaxAssignmentDayCountSelect">
                  <div class="text-subtitle-2 pb-2">Max antal dagar per jobb</div>
                  <v-btn-toggle
                    v-model="viewData.accessibilityData.maxAssignmentDayCount"
                    class="mb-3 xDenseToggle"
                    color="blue darken-4"
                    mandatory
                  >
                    <v-btn
                      v-for="maxAssignmentDayCountOption in viewData.accessibilityData.maxAssignmentDayCountOption_ar"
                      :key="maxAssignmentDayCountOption.value"
                      :value="maxAssignmentDayCountOption.value"
                      text
                      small
                      @click="lazySaveAccessibility()"
                    >
                      {{ maxAssignmentDayCountOption.text }}
                    </v-btn>
                  </v-btn-toggle>
                </template>
              </v-form>
            </v-card-text>
          </v-card>
          <!--driver data-card-->
          <app-data-card v-if="isDriver" title="Konto" :data_ar="viewData.presentationData.driverData_ar" @edit="onEdit('driver')" class="mb-6"></app-data-card>
          <!--company data-card-->
          <app-data-card v-if="isCompany" title="Åkerikonto" :data_ar="viewData.presentationData.companyData_ar" @edit="onEdit('company')" class="mb-6"></app-data-card>
        </v-col>
        <v-col v-if="isDriver" cols="12" sm="6">
          <!--matching data-card-->
          <v-card
            v-if="this.isGreen"
            class="mx-auto mb-6"
            color="secondary"
            dark
          >
            <v-card-title>Yrkesprofil</v-card-title>
            <v-card-text
              dark
            >
              För att kunna matchas mot jobb måste du skapa en yrkessprofil
              <br>
              <v-btn
                class="mt-4"
                color="accent"
                @click="onEdit('matching')"
              >
                Skapa yrkesprofil
              </v-btn>
            </v-card-text>
          </v-card>
          <app-data-card v-else title="Yrkesprofil" :data_ar="viewData.presentationData.matchingData_ar" @edit="onEdit('matching')" class="mb-6"></app-data-card>
        </v-col>
        <v-col cols="12" v-if="isCompany" :sm="6">
          <!--user data-card-->
          <app-data-card title="Användarkonto" :data_ar="viewData.presentationData.userData_ar" @edit="onEdit('user')" class="mb-6"></app-data-card>
        </v-col>
      </v-row>
      <!--profile status ifs-->
      <template
        v-if="viewData.statusData.status === 'active'"
      >
        <!--when profile is removable--->
        <v-banner
          app
          color="grey lighten-3"
          icon="mdi-information"
          class="text-left"
        >
          <div class="text-h6">Radera konto</div>
          <div class="text-body-2">
            Du kan själv radera ditt konto inklusive alla dina uppgifter via knappen "Radera konto" nedan. Ditt konto raderas då efter en timme, och du har möjlighet att ångra dig tills dess.
          </div>
          <template v-slot:actions>
            <v-btn
              color="error"
              text
              @click.stop="removeProfileDialog = true"
            >Radera konto</v-btn>
          </template>
        </v-banner>
        <!--removeProfileDialog-->
        <v-dialog
          v-model="removeProfileDialog"
          max-width="320"
          dark
        >
          <v-card>
            <v-card-title class="headline">Radera konto</v-card-title>
            <v-card-text>
              Vill du verkligen ta bort ditt konto med alla dina uppgifter?
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="removeProfileDialog = false"
              >
                Nej
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                text
                @click="removeProfile()"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template
        v-else-if="viewData.statusData.status === 'deleteRequested'"
      >
        <!--delete requested-->
        <v-banner
          app
          color="error"
          dark
          icon="mdi-alert"
          class="text-left"
        >
          <div class="text-h6">Radering begärd</div>
          <div class="text-body-2">
            Du begärde {{ viewData.statusData.deleteRequestedAt }} att få ditt konto raderat. Ditt konto kommer att tas bort en timme efter tidpunkten.
          </div>
          <template v-slot:actions>
            <v-btn @click.stop="regretRemoveProfile()">Ångra</v-btn>
          </template>
        </v-banner>
      </template>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import ViewToolbar from '../components/ViewToolbar'
import SnackBar from '../components/SnackBar'
import DataCard from '../components/DataCard'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-data-card': DataCard,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  computed: {
    ...mapGetters(['access_token', 'loggedInData', 'agentName', 'agentId', 'isGreen', 'getHomeRoute']),
    isCompany() {
      return this.loggedInData.agentData.type == 'company'
    },
    isDriver() {
      return this.loggedInData.agentData.type == 'driver'
    },
    showJobLengthButtons() {
      return this.viewData.accessibilityData.assignmentWeekdayAll == 1 || this.viewData.accessibilityData.assignmentWeekday_ar.length > 1
    },
    showMaxAssignmentDayCountSelect() {
      return this.viewData.accessibilityData.assignmentSingleDayOnly == 0 && this.viewData.accessibilityData.assignmentWeekdayAll == 1
    }
  },
  data() {
    return {
      viewDataIsLoaded: false,
      viewData: {},
      removeProfileDialog: false,
      lazySaveTimeout: null,
      lazySaveMs: 700,
      dayModes: [
        {
          value: 1,
          name: "1-dagars"
        },
        {
          value: 0,
          name: "Flerdagars"
        },
      ],
      weekdayModes: [
        {
          value: 1,
          name: "Alla"
        },
        {
          value: 0,
          name: "Urval"
        },
      ],
      weekdays: [
        {
          value: 1,
          name: "Må"
        },
        {
          value: 2,
          name: "Ti"
        },
        {
          value: 3,
          name: "On"
        },
        {
          value: 4,
          name: "To"
        },
        {
          value: 5,
          name: "Fr"
        },
        {
          value: 6,
          name: "Lö"
        },
        {
          value: 7,
          name: "Sö"
        },
      ]
    }
  },
  methods: {
    onEdit(referer) {
      switch (referer) {
        case 'user':
          this.$router.push({ name: 'user-edit', params: { id: this.loggedInData.userData.id }} )
          break
        case 'driver':
          this.$router.push({ name: 'driver-edit', params: { id: this.agentId }} )
//          console.log('this.agentId', this.agentId)
          break
        case 'matching':
          this.$router.push({ name: 'matching-edit', params: { id: this.agentId }} )
          break
        case 'company':
          this.$router.push({ name: 'company-edit', params: { id: this.agentId }} )
          break
      }
    },
    lazySaveAccessibility() {
      if (this.viewData.accessibilityData.assignmentWeekday_ar.length == 7) {
        //fix if user clicks all weekdays
        this.viewData.accessibilityData.assignmentWeekday_ar = []
        this.viewData.accessibilityData.assignmentWeekdayAll = 1
      }
      clearTimeout(this.lazySaveTimeout)
      this.lazySaveTimeout = setTimeout(this.saveAccessibility, this.lazySaveMs)
    },
    saveAccessibility() {
      let formIsValid = true
      if (this.viewData.accessibilityData.assignmentWeekdayAll == 0 && this.viewData.accessibilityData.assignmentWeekday_ar.length == 0) {
        //no weekdays defined
        formIsValid = false
      }
      if (!formIsValid) {
        return
      }
      //compose postData
      let postData = {
        accessibilityData: this.viewData.accessibilityData
      }
      //set config for axios request
      let config = {
        headers: {
          'Authorization': this.access_token,
        }
      }
      let url = this.url_composeApiUrl('/driver/accessibility-save')
//      console.log('post', postData)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('response', response)
          if (response.data.success) {
            //success
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    removeProfile() {
      this.removeProfileDialog = false
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/user/profile')
//      console.log('delete', url)
      axios.delete(url, config)
        .then(response => {
//          console.log('response', response)
          if (response.data.success) {
            //success - load new view data
            this.loadViewData()
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    regretRemoveProfile() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/user/regret-profile-delete')
//      console.log('get', url)
      axios.get(url, config)
        .then(response => {
//          console.log('response', response)
          if (response.data.success) {
            //success - load new view data
            this.loadViewData()
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    doOnViewData(returnData) {
      this.viewData = returnData
      this.viewDataIsLoaded = true
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let postData = {
        agentData: this.loggedInData.agentData
      }
      let url = this.url_composeApiUrl('/user/profile')
//      console.log('post url: ' + url, postData)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('post response', response)
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    }  
  },
  created() {
    //get viewData
    this.loadViewData()
  }
}
</script>

<style>

</style>